import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { joinURLs } from "../utils/urlUtil";
import axios from "axios";

type AuthTokenSetterProps = {
  onReady: () => void;
};

const AuthTokenSetter = ({ onReady }: AuthTokenSetterProps): JSX.Element | null => {
  const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    const storeToken = async () => {
      if (isLoading) return;

      if (isAuthenticated) {
        try {
          const token = await getAccessTokenSilently();
          const url = joinURLs("authcookie", process.env.REACT_APP_JUPITER_API_BASE_URL);

          await axios.post(url, { token }, {
            withCredentials: true,
            headers: { "Content-Type": "application/json" }
          });
        } catch (err) {
          console.error("Failed to set auth token:", err);
        }
      }

      // Either way — continue to render the app
      onReady();
    };

    storeToken();
  }, [isLoading, isAuthenticated, getAccessTokenSilently, onReady]);


  return null;
};

export default AuthTokenSetter;